import { render, staticRenderFns } from "./HomeNavigationCards.vue?vue&type=template&id=9630c168&scoped=true"
import script from "./HomeNavigationCards.js?vue&type=script&lang=js&external"
export * from "./HomeNavigationCards.js?vue&type=script&lang=js&external"
import style0 from "./HomeNavigationCards.scss?vue&type=style&index=0&id=9630c168&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9630c168",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HotNavigationCard: require('/runner/_work/app-hotmart-legal/app-hotmart-legal/components/Molecules/NavigationCard/NavigationCard.vue').default})
